import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeliveryinline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(1 10)",
		stroke: "currentColor",
		strokeWidth: 2,
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M42 7.793h9.252a2 2 0 011.312.49l8.748 7.602a2 2 0 01.688 1.51v17.553h0-20V7.793z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 14.5,
				cy: 39.5,
				r: 4.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 49.5,
				cy: 39.5,
				r: 4.5
			}),
			/* @__PURE__ */ _jsx("path", { d: "M3 13.788V3.182C3 1.909 3.803 0 5 0h35c1.197 0 2 1.91 2 3.182V35H5c-1.197 0-2-.849-2-2.121v-8.485M0 15h19M42 18h19M23 15h2M47 23h2" })
		]
	})
});
export default SvgDeliveryinline;
